import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { MINUTE } from './constants';
import Timer from './timer';

export interface State {
    now: Date | null;
}

export interface InjectedProps {
    now: Date | null;
}

export default function withTime<T extends InjectedProps>(WrappedComponent: React.ComponentType<T>, tick = MINUTE) {
    class WithTime extends React.Component<T, State> {
        static displayName = `withTime(${WrappedComponent.displayName})`;

        constructor(props: T) {
            super(props);

            if (!isSSR) {
                this.timer = Timer.getInstance(this.updateTime);
                this.state = {
                    now: this.timer.now(),
                };
            }
        }

        state: InjectedProps = {
            now: null,
        };

        componentDidMount() {
            this.interval = setInterval(this.updateTime, tick);
        }

        componentWillUnmount() {
            clearInterval(this.interval);
        }

        timer: Timer;
        interval: ReturnType<typeof setInterval>;

        updateTime = () => {
            const now = Timer.getInstance().now();

            this.setState({
                now,
            });
        };

        render() {
            const { now } = this.state;

            return <WrappedComponent {...this.props} now={now} />;
        }
    }

    return hoistNonReactStatics(WithTime, WrappedComponent) as React.ComponentType<Omit<T, keyof InjectedProps>>;
}
